export default __webpack_public_path__ + "static/media/lt.b40a2987.svg";